<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top-off" style="background-color: #ffffff">
	<!-- 				 -->
	<!-- School Selector -->
	<!-- 				 -->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchool"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r">{{r.SchoolNumber}} - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector
					[ShowAll]="SchoolSelectShowAll"
					[ShowAllID]="SchoolSelectShowAllID"
					[ShowAllText]="SchoolSelectShowAllText"
					[OverrideSchools]="true"
					[lstSchool]="lstSchool"
				>
				</caass-schoolselector>
			</div>

			<div class="radio-body">
				<div>
					<p-radioButton
						name="groupSelectorMode"
						value="1"
						[(ngModel)]="SchoolSelectorMode"
						(onClick)="onRadioMode1()"
						[disabled]="isBusy == true"
					></p-radioButton>
				</div>
				<div style="margin-left: 5px">
					<label>Print Pending</label>
				</div>
				<div style="margin-left: 15px">
					<p-radioButton
						name="groupSelectorMode"
						value="2"
						[(ngModel)]="SchoolSelectorMode"
						(onClick)="onRadioMode2()"
						[disabled]="isBusy == true"
					></p-radioButton>
				</div>
				<div style="margin-left: 5px">
					<label>All Express</label>
				</div>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()" [disabled]="isBusy == true">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onChangeStatus()" [disabled]="isBusy == true">Change Status</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total items in express queue: {{ lstPrintQueue.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<!-- 			  -->
<!-- Total Counts -->
<!-- 			  -->
<div class="table-totals-body">
	<div class="table-totals-data" style="margin-left: 0px">
		<div>Print pending:</div>
		<div class="table-totals-counts">{{ SchoolTotalSubmitted }}</div>
	</div>

	<div class="table-totals-data">
		<div>Today printed:</div>
		<div class="table-totals-counts">{{ SchoolPrintedToday }}</div>
	</div>

	<div class="table-totals-data">
		<div>Total printed:</div>
		<div class="table-totals-counts">{{ SchoolTotalPrinted }}</div>
	</div>

	<div class="table-totals-data">
		<div>Submit Deadline Time:</div>
		<div class="table-totals-counts">
			{{ SubmitCutoffTime | date : "shortTime" }}
		</div>
	</div>
</div>

<!-- 					  -->
<!-- Display PrintQ Items -->
<!-- 					  -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydt
		[value]="lstPrintQueue"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		styleClass="p-datatable-striped"
		[(selection)]="lstPrintQueueChecked"
		[rowHover]="true"
		dataKey="IDDepotPrintQueueID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		sortMode="multiple"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th style="width: 3rem">
					<!-- 				   -->
					<!-- Display When Busy -->
					<!-- 				   -->
					<div [style.display]="isBusy == true ? 'block' : 'none'">
						<img class="busy-img" src="assets/images/loading.gif" />
					</div>
				</th>

				<th></th>
				<!-- Placeholder -->

				<th>
					<div class="p-d-flex" [style.display]="isShowComment == false ? 'block' : 'none'">
						<button
							pButton
							style="width: 100px"
							label="Comment"
							class="p-button-outlined"
							icon="pi pi-plus-circle"
							(click)="ontoggleComment()"
						></button>
					</div>
					<div class="p-d-flex" [style.display]="isShowComment == true ? 'block' : 'none'">
						<button
							pButton
							style="width: 100px"
							label="Comment"
							class="p-button-outlined"
							icon="pi pi-minus-circle"
							(click)="ontoggleComment()"
						></button>
					</div>
				</th>

				<th></th>
				<!-- Placeholder -->
				<th></th>
				<!-- Placeholder -->

				<th style="text-align: right">
					<div class="p-d-flex">
						<button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="onClearFilters()"></button>
					</div>
				</th>

				<th>
					<p-columnFilter field="IDDepotPrintQueueStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPrintQueueStatus
								[ngModel]="value"
								[options]="lstPrintQueueStatuses"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="IDDepotPrintReasonDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPrintReason
								[ngModel]="value"
								[options]="lstPrintReasons"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th [style.display]="isShowComment == true ? 'table-cell' : 'none'"></th>
				<!-- Comment Placeholder -->
				<th></th>
				<!-- Placeholder -->
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr>
				<th style="width: 3rem">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="StudentID">StudentID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="HasPhoto" class="fixwidth-07">Photo<p-sortIcon field="HasPhoto"></p-sortIcon></th>
				<th pSortableColumn="LastName">Full Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="SubmittedDT">Submitted<p-sortIcon field="SubmittedDT"></p-sortIcon></th>
				<th pSortableColumn="PrintedDT">Printed<p-sortIcon field="PrintedDT"></p-sortIcon></th>
				<th pSortableColumn="IDDepotPrintQueueStatusDesc">Status<p-sortIcon field="IDDepotPrintQueueStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="IDDepotPrintReasonDesc">Print Reason<p-sortIcon field="IDDepotPrintReasonDesc"></p-sortIcon></th>
				<th [style.display]="isShowComment == true ? 'table-cell' : 'none'" pSortableColumn="Comment">
					Comment<p-sortIcon field="Comment"></p-sortIcon>
				</th>
				<th pSortableColumn="IsMTAOverride">{{ PublicTransitLabel }} Override<p-sortIcon field="IsMTAOverride"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rPrintQueueItem>
			<tr [pSelectableRow]="rPrintQueueItem">
				<td>
					<div>
						<p-tableCheckbox [value]="rPrintQueueItem"></p-tableCheckbox>
					</div>
				</td>

				<td>
					<div>{{ rPrintQueueItem.StudentID }}</div>
				</td>

				<td>
					<div class="fixwidth-07">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-has-photo-check': rPrintQueueItem.HasPhoto,
								'pi-ban table-no-photo-check': !rPrintQueueItem.HasPhoto
							}"
						></i>
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.FirstName }}
						{{ rPrintQueueItem.LastName }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.SubmittedDTDesc }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.PrintedDTDesc }}
					</div>
				</td>

				<td>
					<div
						[ngClass]="{
							'table-data-status-1': rPrintQueueItem.IDDepotPrintQueueStatusID == 1,
							'table-data-status-2': rPrintQueueItem.IDDepotPrintQueueStatusID == 2,
							'table-data-status-3': rPrintQueueItem.IDDepotPrintQueueStatusID == 3,
							'table-data-status-4': rPrintQueueItem.IDDepotPrintQueueStatusID == 4,
							'table-data-status-5': rPrintQueueItem.IDDepotPrintQueueStatusID == 5
						}"
					>
						{{ rPrintQueueItem.IDDepotPrintQueueStatusDesc }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.IDDepotPrintReasonDesc }}
					</div>
				</td>

				<td [style.display]="isShowComment == true ? 'table-cell' : 'none'">
					<div>
						{{ rPrintQueueItem.Comment }}
					</div>
				</td>

				<td>
					<div>
						{{ rPrintQueueItem.IsMTAOverrideDesc }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						 -->
<!-- Display When No Q Items -->
<!-- 					     -->
<div style="padding: 20px" [style.display]="lstPrintQueue.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No items to print...</label>
</div>
